import React, { PropsWithChildren } from 'react'

export enum DetailsVariants {
  Dark = 'dark',
  Light = 'light',
}

type DetailsContainerProps = {
  variant: DetailsVariants
}

const DetailsContainer = ({
  children,
  variant,
}: PropsWithChildren<DetailsContainerProps>) => {
  return (
    <div
      className={`${
        variant === DetailsVariants.Dark
          ? 'bg-[#001a3d]'
          : 'bg-white border-[#001a3d] border-[3px]'
      } w-[325px] md:w-[440px] h-[282px] md:h-[400px] p-5 md:p-10 rounded-2xl shadow-[-10px_-10px_30px_0px_rgba(39,92,141,0.12)] flex-col justify-start items-start gap-5 md:gap-10 inline-flex tracking-wide`}
    >
      {children}
    </div>
  )
}

export default DetailsContainer
